import { createAsyncThunk } from '@reduxjs/toolkit';
import { modelosDecursoService } from './services';
import type { ListModelosResult } from '@/features/modelos-documento/api';
import type { ListarModelosDecursoArgs } from '../../types/modelosDecurso';

export const listarModelosDecurso = createAsyncThunk<
  ListModelosResult,
  ListarModelosDecursoArgs,
  { rejectValue: string }
>('modelosDecurso/listar', async (args, { rejectWithValue }) => {
  try {
    return await modelosDecursoService.listar(args);
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar os modelos.');
  }
});
